module.exports = __webpack_public_path__ + "media/images/step_optimisation_cs-be2b160075d0ef81a91b50ed78314ed8.svg";